import styled from 'styled-components';
import { media } from '../../../Utils/mediaQueries';

export const MainContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    background-color: #000;
`;

export const Header = styled.div`
    width: 100%;
    height: 50px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 0 20px;

    background-color: #000;

    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
`;

export const ClassesContainer = styled.div`
    width: 30%;
    height: 100%;
    position: relative;

    display: flex;
    flex-direction: column;

    ${media.tablet`
        width: 40%;
    `};

    ${media.phone`
        width: 100%;
    `};
`;

export const ClassesContentContainer = styled.div`
    margin-top: 50px;
    width: 100%;
    height: calc(100% - 130px);
    flex: 1;
    background-color: #151517;
    position: relative;

    display: flex;
    align-items: center;
`;

export const FixedWrapper = styled.div`
    width: 100%;
    height: 100%;
    flex: 1;
    position: relative;
`;

export const ClassesContent = styled.div`
    width: 100%;
    height: 100%;
    padding: 80px 30px 0 30px;
    flex: 1;
    background-color: #151517;
    max-height: 100%;
    position: relative;
    overflow: scroll;
    position: relative;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const MembersContainer = styled.div`
    width: 70%;
    height: 100%;
    background-color: #000;
    position: relative;
    overflow: hidden;

    flex: 1;

    ${media.tablet`
        width: 60%;
    `};

    ${media.phone`
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1000000;  
    `};
`;

export const EmptyMembersContainer = styled.div`
    width: 70%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    ${media.tablet`
        width: 60%;
    `};

    ${media.phone`
        display: none;
    `};
`;

export const MembersContent = styled.div`
    width: 100%;
    height: 100%;
    padding: 80px 30px 0 30px;
    flex: 1;
    background-color: #000;
`;

export const PaginatorHeader = styled.div`
    width: 100%;
    height: 50px;
    background-color: #151517;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10000;

    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    align-items: center;
`;

export const DateToggleButton = styled.div`
    color: ${props => (props.hide ? '#151517' : 'white')};
    cursor: ${props => (props.hide ? 'default' : 'pointer')};
    font-size: 20px;
`;

export const ListContainer = styled.div`
    width: 100%;
    height: 50%;
    overflow: auto;
    padding-right: 15px;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    position: relative;
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/CheckIn/style.js